import { useState } from 'react';
import type { CardInfo } from '@lub0v/santa-utils';
import { Button, Stack, Typography } from '@src/components';
import { GifteePair } from '@src/components';

export interface SecretPairProps {
  /** Who gives. */
  santa: CardInfo;
  /** Who receives. */
  giftee: CardInfo;
  /** The question, phrased around whichever side the organizer asked about. */
  question: string;
  revealLabel: string;
  santaLabel: string;
  gifteeLabel: string;
  testId?: string;
}

/**
 * A pair the organizer has to ask for twice. An organizer often plays in their
 * own draw, so a mis-click should not spoil it: the names stay behind a second
 * deliberate press.
 */
export function SecretPair({
  santa,
  giftee,
  question,
  revealLabel,
  santaLabel,
  gifteeLabel,
  testId,
}: SecretPairProps) {
  const [revealed, setRevealed] = useState(false);

  if (revealed) {
    return (
      <GifteePair
        santa={santa}
        giftee={giftee}
        santaLabel={santaLabel}
        gifteeLabel={gifteeLabel}
        testId={testId ? `${testId}-pair` : undefined}
      />
    );
  }

  return (
    <Stack gap={5} align="center">
      <Typography as="p" role="body/base">
        {question}
      </Typography>
      <Button
        variant="primary"
        size="large"
        onClick={() => setRevealed(true)}
        testId={testId ? `${testId}-reveal` : undefined}
      >
        {revealLabel}
      </Button>
    </Stack>
  );
}
